<template>
  <div>
    <b-modal
      id="modal-material-warehouse"
      title="Поделиться материалы"
      cancel-variant="outline-secondary"
      :ok-title="$t('save')"
      ok-variant="success"
      :cancel-title="$t('cancel')"
      centered
      size="md"
      no-close-on-backdrop
    >
      <b-form>
        <b-form-group
          :label="$t('reference.name')"
        >
          <b-form-input
            v-model="material.title"
            readonly
          />
        </b-form-group>

        <b-form-group
          :label="$t('view')"
        >
          <b-form-input
            v-model="material.vid"
            readonly
          />
        </b-form-group>

        <b-form-group
          :label="$t('reference.units')"
        >
          <v-select
            v-model="material.units"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            :options="option"
          />
        </b-form-group>

        <b-form-group
          :label="$t('amount')"
        >
          <v-select
            v-model="material.count"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            :options="option"
          />
        </b-form-group>

        <b-form-group
          :label="$t('to_whom')"
        >
          <v-select
            v-model="material.whom"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            :options="option"
          />
        </b-form-group>

        <b-form-group
          :label="$t('courses.file')"
        >
          <b-form-file
            v-model="material.file"
            multiple
            :placeholder="$t('choose_file_or_drop')"
            @input="handleFileInput"
          />

          <div
            v-for="(item,index) in selectedFiles"
            :key="item.id"
            class="d-flex align-items-center justify-content-between mt-1"
          >
            <b-link
              class="text-decoration"
            >

              <span v-if="material.file">
                {{ item.name }}
              </span>
            </b-link>

            <b-button
              class="p-50"
              size="sm"
              variant="danger"
              @click="handleDeleteFile(index)"
            >
              <feather-icon
                icon="TrashIcon"
              />
            </b-button>
          </div>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BForm,
  BFormInput,
  BFormGroup,
  BFormFile,
  BLink,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BButton,
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    vSelect,
    BFormFile,
    BLink,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      material: {
        title: '',
        vid: '',
        units: null,
        count: null,
        whom: null,
        file: [],
      },
      selectedFiles: [],
      option: [],
    }
  },
  methods: {
    handleFileInput() {
      this.selectedFiles.push(...this.material.file)
    },

    handleDeleteFile(fileKey) {
      this.material.file.splice(fileKey, 1)
      this.selectedFiles.splice(fileKey, 1)
    },
  },
}
</script>
